export const header = 'Reset your\n password';
export const infoText =
  "Enter the email address associated\nwith your account and we'll send you a\nlink to reset your password.";
export const buttonText = 'SUBMIT';
export const buttonSubmittingText = 'SUBMITTING...';
export const instructionsSentText =
  'Your reset password instructions have been sent to your email. Follow the instructions in the email to reset your password. The link will be valid for the next 24 hours.';
export const backToLoginText = 'Back to login';
